import { Icon } from 'shared/iconpack'

import { HTMLAttributes } from 'react'

import { useNavigate } from 'react-router-dom'

import { Button } from 'shared/ui/Button'
import Title from 'shared/ui/Title'

import { palette } from 'shared/config/styles/palette'

interface Props extends HTMLAttributes<HTMLDivElement> {
  type: 'notFound' | 'noAccess' | 'underMaintenance' | 'someWrong'
  size: 'large' | 'small'
  title: string
  description?: string
  btnText?: string
  onClick?: () => void
}

const CustomEmpty = ({
  type,
  size,
  title,
  className,
  description,
  btnText,
  onClick,
}: Props) => {
  const navigate = useNavigate()
  const goBack = () => {
    navigate(-1)
  }
  return (
    <div
      className={`flex flex-col items-center gap-[24px] text-center ${className}`}
    >
      <div
        className={`flex items-center justify-center rounded-full bg-snow_gray ${size === 'small' ? 'p-[15px]' : 'p-[30px]'}`}
      >
        <Icon
          name={type}
          size={size === 'small' ? 84 : 140}
          color={palette.light_gray_15}
        />
      </div>
      <div className={`flex flex-col items-center gap-[12px]`}>
        <Title
          className={`!mb-0 !text-dark !font-bold ${size === 'small' ? '!text-[20px] !leading-[28px]' : '!text-[30px] !leading-[40px]'}`}
          level={size === 'small' ? 4 : 3}
        >
          {title}
        </Title>
        {description && (
          <span
            className={`text-black/[.45] ${size === 'small' ? 'text-[16px] leading-[24px]' : 'text-[18px] leading-[26px]'}`}
          >
            {description}
          </span>
        )}
      </div>
      {btnText && (
        <Button
          onClick={onClick || goBack}
          className={`h-auto !text-white font-medium !bg-dark_blue_1 border-none 
            ${
              size === 'small'
                ? 'py-[5.8px] px-[9.38px] text-[9.38px] leading-[14.08px] rounded-[6.8px]'
                : 'py-[10px] px-[16px] text-[16px] leading-[24px] rounded-[12px]'
            }`}
        >
          {btnText}
        </Button>
      )}
    </div>
  )
}

export default CustomEmpty
